window.addEventListener("load", () =>
{
    document.querySelectorAll(".needs-validation").forEach((form) =>
    {
        if (form instanceof HTMLFormElement)
        {
            form.addEventListener("submit", (event) =>
            {
                if (!form.checkValidity())
                {
                    event.preventDefault();
                    event.stopPropagation();
                }

                form.classList.add("was-validated");
            }, false);
        }
    });
}, false);

export {};
